import { render, staticRenderFns } from "./SelectDigiBoards.vue?vue&type=template&id=4c236b4f&scoped=true"
import script from "./SelectDigiBoards.vue?vue&type=script&lang=js"
export * from "./SelectDigiBoards.vue?vue&type=script&lang=js"
import style0 from "./SelectDigiBoards.vue?vue&type=style&index=0&id=4c236b4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c236b4f",
  null
  
)

export default component.exports